import type { Utilisateur } from '@/shared/auth/types';

/**
 * Les données fictives du mode démo (`npm run dev:demo`).
 *
 * Mêmes personnages que les maquettes de docs/maquettes/, pour qu'on retrouve
 * dans l'application ce qu'on a validé sur papier. Rien ici n'atteint un build.
 */
export const PARTENAIRES_DEMO = [
  { id: 'p-batisud', raisonSociale: 'Bâti Sud Charpente' },
  { id: 'p-solaire-aveyron', raisonSociale: 'Solaire Aveyron Pose' },
  { id: 'p-aero-sechage', raisonSociale: 'Aéro Séchage Services' },
  { id: 'p-energie-pei', raisonSociale: 'Énergie Péi Réunion' },
] as const;

export const COMPTES_DEMO: Utilisateur[] = [
  {
    id: 'u-bureau',
    email: 'bureau@vla-energie.demo',
    nom: 'Claire Martin',
    role: 'bureau',
    partenaireId: null,
    partenaireNom: null,
    actif: true,
  },
  {
    id: 'u-batisud',
    email: 'p.garrigues@batisud.demo',
    nom: 'Pierre Garrigues',
    role: 'partenaire',
    partenaireId: 'p-batisud',
    partenaireNom: 'Bâti Sud Charpente',
    actif: true,
  },
  {
    id: 'u-aveyron',
    email: 'm.fabre@solaire-aveyron.demo',
    nom: 'Marc Fabre',
    role: 'partenaire',
    partenaireId: 'p-solaire-aveyron',
    partenaireNom: 'Solaire Aveyron Pose',
    actif: true,
  },
  {
    id: 'u-attente',
    email: 'nouveau@aero-sechage.demo',
    nom: '',
    role: 'partenaire',
    partenaireId: null,
    partenaireNom: null,
    actif: true,
  },
];

/** Horodatages relatifs à l'ouverture de la démo, pour que « il y a 2 h » reste vrai. */
function ilYa(minutes: number): string {
  return new Date(Date.now() - minutes * 60_000).toISOString();
}

export const JOURNAL_DEMO = [
  {
    id: 6,
    horodatage: ilYa(35),
    acteurNom: 'Claire Martin',
    action: 'modification' as const,
    objetType: 'profils',
    objetId: 'u-aveyron',
    libelle: 'm.fabre@solaire-aveyron.demo',
    changements: { partenaire_id: [null, 'p-solaire-aveyron'] },
  },
  {
    id: 5,
    horodatage: ilYa(42),
    acteurNom: null,
    action: 'creation' as const,
    objetType: 'profils',
    objetId: 'u-attente',
    libelle: 'nouveau@aero-sechage.demo',
    changements: {},
  },
  {
    id: 4,
    horodatage: ilYa(60 * 3),
    acteurNom: 'Claire Martin',
    action: 'modification' as const,
    objetType: 'partenaires',
    objetId: 'p-batisud',
    libelle: 'Bâti Sud Charpente',
    changements: { raison_sociale: ['Bati Sud', 'Bâti Sud Charpente'] },
  },
  {
    id: 3,
    horodatage: ilYa(60 * 26),
    acteurNom: 'Claire Martin',
    action: 'creation' as const,
    objetType: 'partenaires',
    objetId: 'p-energie-pei',
    libelle: 'Énergie Péi Réunion',
    changements: {},
  },
  {
    id: 2,
    horodatage: ilYa(60 * 27),
    acteurNom: 'Claire Martin',
    action: 'suppression' as const,
    objetType: 'partenaires',
    objetId: 'p-doublon',
    libelle: 'Aero Sechage (doublon)',
    changements: {},
  },
  {
    id: 1,
    horodatage: ilYa(60 * 50),
    acteurNom: null,
    action: 'creation' as const,
    objetType: 'profils',
    objetId: 'u-bureau',
    libelle: 'bureau@vla-energie.demo',
    changements: {},
  },
];
